import { render, staticRenderFns } from "./payrollitems.vue?vue&type=template&id=ab68e8fc&scoped=true"
import script from "./payrollitems.vue?vue&type=script&lang=js"
export * from "./payrollitems.vue?vue&type=script&lang=js"
import style0 from "./payrollitems.vue?vue&type=style&index=0&id=ab68e8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab68e8fc",
  null
  
)

export default component.exports